import { render, staticRenderFns } from "./BasicCkeditor.vue?vue&type=template&id=f90fe964"
import script from "./BasicCkeditor.vue?vue&type=script&lang=js"
export * from "./BasicCkeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports